<template>
  <n-card :title="title" :size="size">
    <template #header-extra><slot name="header-extra"></slot></template>
    <slot></slot>
    <template #footer><slot name="footer"></slot></template>
    <template #action><slot name="action"></slot></template>
  </n-card>
</template>

<script setup lang="ts">
import { NCard } from "naive-ui";

defineProps<{
  title?: string;
  size?: "small" | "medium" | "large" | "huge";
}>();
</script>
